/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Minimum_DescriptionInputs */

const et_plan_minimum_description = /** @type {(inputs: Plan_Minimum_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google esimesele lehele 90 päevaga.`)
};

const en_plan_minimum_description = /** @type {(inputs: Plan_Minimum_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google first page within 90 days.`)
};

/**
* | output |
* | --- |
* | "Google first page within 90 days." |
*
* @param {Plan_Minimum_DescriptionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_minimum_description = /** @type {((inputs?: Plan_Minimum_DescriptionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Minimum_DescriptionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_minimum_description(inputs)
	return en_plan_minimum_description(inputs)
});